import React, { useState } from "react";
import "./signupSection.scss";
import { connect } from "react-redux";
import TextBox from "../../atoms/textbox";
import { toast } from "react-toastify";
import ButtonInput from "../../atoms/button";
import sms from "../../assets/images/sms.png";
import backButton from "../../assets/images/arrow-left.svg";
import { Box, CircularProgress } from "@mui/material";

import { updateUserData, forgotPassword } from "../../redux/action/user";

const LoginForgotPassword = (props) => {
  const [loading, setLoading] = useState(false);

  const emailChange = (value) => {
    props.updateUserData({
      ...props.user,
      email: value,
    });
  };

  const gotoOTP = async () => {
    const email = props?.user?.email?.trim();
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,7}$/i.test(email)) {
      toast.error("Please enter a valid email");
      return;
    }

    setLoading(true);
    try {
      await props.forgotPassword(email);
      toast.success("Please check your email for the verification code");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const gotoLogin = () => {
    props.updateUserData({
      ...props.user,
      status: "login",
      isNewUser: false,
      otp: "",
    });
  };

  return (
    <div className="login_form">
      <div className="container-fluid">
        <div className="row">
          <h2 className="title">Don't worry We're here to help you!</h2>
          <p className="subTitle">
            Enter your email you used to join and we will send you the
            verification code.
          </p>
        </div>
        <Box mb={3} mt={1}>
          <TextBox
            placeholder="Email Address"
            value={props.user.email || ""}
            valueChange={emailChange}
            prefix={sms}
          />
        </Box>
        <div>
          <ButtonInput
            text={
              loading ? (
                <CircularProgress size={25} color="success" />
              ) : (
                "SEND"
              )
            }
            onSubmit={gotoOTP}
            disabled={loading}
          />
          <ButtonInput
            text="Back"
            class="back-button"
            onSubmit={gotoLogin}
            iCon={backButton}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
};

LoginForgotPassword.propTypes = {};
LoginForgotPassword.defaultProps = {};

const actionCreators = {
  updateUserData,
  forgotPassword,
};

export default connect(
  ({ user }) => ({
    user,
    forgotPass: user.forgotPass,
  }),
  actionCreators
)(LoginForgotPassword);
